import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { Logger } from '../utils/Logger';
import { TransportType, TransportStatus } from '..';
var logger = new Logger('Transport');
/**
 * @internalapi
 *
 *
 */

export var Transport = /*#__PURE__*/function () {
  function Transport(name, client, peerManager) {
    _classCallCheck(this, Transport);

    /**
     * The type of the transport
     */
    this.type = TransportType.POST_MESSAGE;
    /**
     * The status of the transport
     */

    this._isConnected = TransportStatus.NOT_CONNECTED;
    /**
     * The listeners that will be notified when new messages are coming in
     */

    this.listeners = [];
    this.name = name;
    this.client = client;
    this.peerManager = peerManager;
  }
  /**
   * Return the status of the connection
   */


  _createClass(Transport, [{
    key: "connectionStatus",
    get: function get() {
      return this._isConnected;
    }
    /**
     * Returns a promise that resolves to true if the transport is available, false if it is not
     */

  }, {
    key: "connect",
    value:
    /**
     * Connect the transport
     */
    function connect() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                logger.log('connect');
                this._isConnected = TransportStatus.CONNECTED;
                return _context.abrupt("return");

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Disconnect the transport
     */

  }, {
    key: "disconnect",
    value: function disconnect() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                logger.log('disconnect');
                this._isConnected = TransportStatus.NOT_CONNECTED;
                return _context2.abrupt("return");

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * Send a message through the transport
     *
     * @param message The message to send
     * @param recipient The recipient of the message
     */

  }, {
    key: "send",
    value: function send(message, peer) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this = this;

        var knownPeers, promises;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!peer) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return", this.client.sendMessage(message, peer));

              case 4:
                _context3.next = 6;
                return this.getPeers();

              case 6:
                knownPeers = _context3.sent;
                // A broadcast request has to be sent everywhere.
                promises = knownPeers.map(function (peerEl) {
                  return _this.client.sendMessage(message, peerEl);
                });
                _context3.next = 10;
                return Promise.all(promises);

              case 10:
                return _context3.abrupt("return", _context3.sent[0]);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
    /**
     * Add a listener to be called when a new message is received
     *
     * @param listener The listener that will be registered
     */

  }, {
    key: "addListener",
    value: function addListener(listener) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                logger.debug('addListener', listener);
                this.listeners.push(listener);
                return _context4.abrupt("return");

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
    /**
     * Remove a listener
     *
     * @param listener
     */

  }, {
    key: "removeListener",
    value: function removeListener(listener) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                logger.log('removeListener');
                this.listeners = this.listeners.filter(function (element) {
                  return element !== listener;
                });
                return _context5.abrupt("return");

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "getPeers",
    value: function getPeers() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this.peerManager.getPeers());

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "addPeer",
    value: function addPeer(newPeer) {
      var _sendPairingResponse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                logger.log('addPeer', 'adding peer', newPeer);
                _context7.next = 3;
                return this.peerManager.addPeer(newPeer);

              case 3:
                _context7.next = 5;
                return this.listen(newPeer.publicKey);

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "removePeer",
    value: function removePeer(peerToBeRemoved) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                logger.log('removePeer', 'removing peer', peerToBeRemoved);
                _context8.next = 3;
                return this.peerManager.removePeer(peerToBeRemoved.publicKey);

              case 3:
                if (!this.client) {
                  _context8.next = 6;
                  break;
                }

                _context8.next = 6;
                return this.client.unsubscribeFromEncryptedMessage(peerToBeRemoved.publicKey);

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "removeAllPeers",
    value: function removeAllPeers() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                logger.log('removeAllPeers');
                _context9.next = 3;
                return this.peerManager.removeAllPeers();

              case 3:
                if (!this.client) {
                  _context9.next = 6;
                  break;
                }

                _context9.next = 6;
                return this.client.unsubscribeFromEncryptedMessages();

              case 6:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
    /**
     * Notify the listeners when a new message comes in
     *
     * @param message Message
     * @param connectionInfo Context info about the connection
     */

  }, {
    key: "notifyListeners",
    value: function notifyListeners(message, connectionInfo) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (this.listeners.length === 0) {
                  logger.warn('notifyListeners', '0 listeners notified!', this);
                } else {
                  logger.log('notifyListeners', "Notifying ".concat(this.listeners.length, " listeners"), this);
                }

                this.listeners.forEach(function (listener) {
                  listener(message, connectionInfo);
                });
                return _context10.abrupt("return");

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
  }], [{
    key: "isAvailable",
    value: function isAvailable() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", Promise.resolve(false));

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));
    }
  }]);

  return Transport;
}();